import apiClient, { prefetchApiCsrfToken } from "../common";

const JSON_API_MEDIA = "application/vnd.api+json";

export async function apiDeleteSupplyDocument(documentId: string): Promise<void> {
  await prefetchApiCsrfToken();
  await apiClient.delete(`supply-documents/${documentId}/`, {
    headers: { Accept: JSON_API_MEDIA },
  });
}
